(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    if (!window.__resourceListCarouselProgressInit) {
    window.__resourceListCarouselProgressInit = true;

    const clampProgress = (value) => {
      if (Number.isNaN(value)) return 0;
      return Math.min(Math.max(value, 0), 1);
    };

    const updateCarouselProgress = (slideshow) => {
      const scroller = slideshow.querySelector('slideshow-slides');
      if (!scroller) return;

      const totalWidth = Math.max(scroller.scrollWidth, 1);
      const viewportWidth = Math.max(scroller.clientWidth, 0);
      const maxScroll = Math.max(totalWidth - viewportWidth, 0);

      const nextButton = slideshow.querySelector('.resource-list__carousel-arrows .slideshow-control--next');
      const isAtEndByButton = nextButton?.hasAttribute('disabled') === true;
      const isAtEndByScroll = maxScroll <= 0 ? true : scroller.scrollLeft >= maxScroll - 1;

      const normalizedProgress = maxScroll <= 0 ? 1 : clampProgress(scroller.scrollLeft / maxScroll);
      const visiblePortion = clampProgress(viewportWidth / totalWidth);

      let progress = maxScroll <= 0 ? 1 : visiblePortion + normalizedProgress * (1 - visiblePortion);
      if (isAtEndByButton || isAtEndByScroll) {
        progress = 1;
      }

      const clampedProgress = clampProgress(progress);

      slideshow.style.setProperty('--resource-list-carousel-progress', String(clampedProgress));
    };

    const bindCarouselProgress = (root = document) => {
      const slideshows = root.querySelectorAll('slideshow-component.resource-list__carousel--enhanced');

      slideshows.forEach((slideshow) => {
        if (slideshow.dataset.resourceListProgressBound === 'true') {
          updateCarouselProgress(slideshow);
          return;
        }

        const scroller = slideshow.querySelector('slideshow-slides');
        if (!scroller) return;

        const handleProgressUpdate = () => updateCarouselProgress(slideshow);

        scroller.addEventListener('scroll', handleProgressUpdate, { passive: true });
        slideshow.addEventListener('slideshow:select', handleProgressUpdate);
        window.addEventListener('resize', handleProgressUpdate);

        if (window.ResizeObserver && !slideshow.__resourceListProgressResizeObserver) {
          const resizeObserver = new ResizeObserver(handleProgressUpdate);
          resizeObserver.observe(scroller);
          slideshow.__resourceListProgressResizeObserver = resizeObserver;
        }

        slideshow.dataset.resourceListProgressBound = 'true';

        updateCarouselProgress(slideshow);
        requestAnimationFrame(() => updateCarouselProgress(slideshow));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindCarouselProgress());
    } else {
      bindCarouselProgress();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindCarouselProgress(event.target);
    });

    document.addEventListener('shopify:section:reorder', (event) => {
      bindCarouselProgress(event.target);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
